import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCrown, FaCoins, FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import '../styles/creditGateModal.css';

const CreditGateModal = ({ isOpen, onClose, onConfirm, type, balance }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgradeClick = () => {
    onClose();
    navigate('/pricing');
  };

  const handleBuyCreditsClick = () => {
    onClose();
    navigate('/pricing', { state: { activeTab: 'credits' } });
  };

  const renderContent = () => {
    if (type === 'pdf_confirm') {
      return (
        <div className="credit-modal-content">
          <div className="credit-modal-header">
            <div className="icon-wrapper coins-icon">
              <FaCoins />
            </div>
            <h2>Export Resume as PDF</h2>
          </div>
          <p className="credit-description">
            Downloading this PDF will consume <strong>100 credits</strong>.
          </p>
          <div className="balance-info-card">
            <span>Your Balance:</span>
            <strong>{balance} credits</strong>
          </div>
          <div className="upsell-box">
            <FaCrown className="crown-gold" />
            <div>
              <h3>Unlimited Downloads</h3>
              <p>Get unlimited free PDF exports and higher AI generation speeds by subscribing.</p>
            </div>
          </div>
          <div className="credit-modal-actions">
            <button className="btn-secondary" onClick={onConfirm}>
              Spend 100 Credits
            </button>
            <button className="btn-primary btn-glow" onClick={handleUpgradeClick}>
              Upgrade for Unlimited exports
            </button>
          </div>
        </div>
      );
    }

    if (type === 'pdf_insufficient') {
      return (
        <div className="credit-modal-content">
          <div className="credit-modal-header">
            <div className="icon-wrapper warning-icon">
              <FaExclamationTriangle />
            </div>
            <h2>PDF Export Locked</h2>
          </div>
          <p className="credit-description">
            Exporting your resume as a PDF requires <strong>100 credits</strong>, but you only have <strong>{balance} credits</strong> remaining.
          </p>
          <div className="upsell-box">
            <FaCrown className="crown-gold" />
            <div>
              <h3>Subscribe for Unlimited</h3>
              <p>Get unlimited downloads and unlock all premium features forever.</p>
            </div>
          </div>
          <div className="credit-modal-actions">
            <button className="btn-secondary" onClick={handleBuyCreditsClick}>
              Buy Credit Packs
            </button>
            <button className="btn-primary btn-glow" onClick={handleUpgradeClick}>
              Upgrade to Subscription
            </button>
          </div>
        </div>
      );
    }

    if (type === 'template_lock') {
      return (
        <div className="credit-modal-content">
          <div className="credit-modal-header">
            <div className="icon-wrapper warning-icon" style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b' }}>
              <FaCrown />
            </div>
            <h2>Premium Template Locked</h2>
          </div>
          <p className="credit-description">
            Modern and Creative resume templates are exclusive premium features. Upgrade your subscription to unlock all layouts and advanced styles.
          </p>
          <div className="credit-modal-actions">
            <button className="btn-secondary" onClick={onClose}>
              Maybe Later
            </button>
            <button className="btn-primary btn-glow" onClick={handleUpgradeClick}>
              Upgrade to Subscription
            </button>
          </div>
        </div>
      );
    }

    // Default: 'ai_insufficient'
    return (
      <div className="credit-modal-content">
        <div className="credit-modal-header">
          <div className="icon-wrapper warning-icon">
            <FaExclamationTriangle />
          </div>
          <h2>Out of Credits!</h2>
        </div>
        <p className="credit-description">
          You do not have enough credits to use this AI feature. Upgrade your subscription for unlimited access or buy a credit pack to top off.
        </p>
        <div className="balance-info-card">
          <span>Your Balance:</span>
          <strong>{balance} credits</strong>
        </div>
        <div className="credit-modal-actions">
          <button className="btn-secondary" onClick={handleBuyCreditsClick}>
            Buy Credit Packs
          </button>
          <button className="btn-primary btn-glow" onClick={handleUpgradeClick}>
            Upgrade to Subscription
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="credit-modal-overlay" onClick={onClose}>
        <div className="credit-modal-card" onClick={(e) => e.stopPropagation()}>
          <div className="credit-modal-drag-handle"></div>
          <button className="credit-modal-close" onClick={onClose} aria-label="Close dialog">
            <FaTimes />
          </button>
          {renderContent()}
        </div>
      </div>
    </>
  );
};

export default CreditGateModal;
